/**
 *
 * NoData
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import PictureInPictureIcon from '../../../assets/v2/PictureInPictureIcon';
import { ALIGNMENT, SIZES } from './constants';
import {
  Container,
  Content,
  Description,
  IconContainer,
  Title,
} from './NoData.styles';

function NoData({
  align = ALIGNMENT.CENTER,
  children,
  description,
  icon,
  size,
  title,
  image,
  isTitleTop,
  showBackground = true,
  ...props
}) {
  return (
    <Container
      $align={align}
      $size={size}
      image={image}
      $showBackground={showBackground}
      {...props}
    >
      <div>
        {isTitleTop && (
          <Title variant="h4" fontWeight="medium">
            {title ?? 'No data available'}
          </Title>
        )}
        <IconContainer>{icon ?? <PictureInPictureIcon />}</IconContainer>
        {!isTitleTop && (
          <Title variant="h4" fontWeight="medium">
            {title ?? 'No data available'}
          </Title>
        )}
        {description && (
          <Description variant="body2">{description}</Description>
        )}
        {children && <Content $align={align}>{children}</Content>}
      </div>

      {image && (
        <div>
          <img src={image} alt="NoDataImage" />
        </div>
      )}
    </Container>
  );
}

NoData.propTypes = {
  align: PropTypes.oneOf(Object.values(ALIGNMENT)),
  children: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  size: PropTypes.oneOf(Object.values(SIZES)),
  image: PropTypes.string,
  title: PropTypes.string,
  isTitleTop: PropTypes.bool,
  showBackground: PropTypes.bool,
};

export default memo(NoData);
